import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'

import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = 'ぼく・わたしのおすすめ　新潟の※コメジルシ！ | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="新潟の※コメジルシ！" />
      <SectionTitle sectionTitle="ぼく・わたしのおすすめ　新潟の※コメジルシ！" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023冬号 No.161 目次",
                path: "/no161"
              },
              {
                name: "新潟の※コメジルシ！"
              }
            ]}
          />

        <p css={style.catchTxt}>小学生のみんなから新潟のいいところを教えてもらいました</p>
        
        <img
          src={`${basePath}/no161/img/4-3.png`}
          alt="コメジルシくん"
          css={style.img(120, "15px 0 0 0")}
        />
        <p css={style.imgCap}>コメジルシくん<br />新潟のいいところを「※（コメジルシ）」と名付けて、※を世界に広めるために活動中!</p>
        
        <p>新潟※（コメジルシ）プロジェクト&emsp;詳しくは
          <a
            href="https://howtoniigata.jp/komepro/"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <h3 css={style.subTitle01}>長岡市の県立歴史博物館の火焔土器</h3>
        <img
          src={`${basePath}/no161/img/4-4.png`}
          alt="長岡市の県立歴史博物館の火焔土器"
          css={style.img(300, "15px 0 0 0")}
        />
        
        <p>すばらしいのでぜひ見に来てください。<br /><span css={style.emphasisWeight}>2年&emsp;橋詰 麻央さん</span></p>

        
        <h3 css={style.subTitle01}>関川村の自宅前の風景</h3>
        <img
          src={`${basePath}/no161/img/4-6.png`}
          alt="関川村の自宅前の風景"
          css={style.img(500, "15px 0 0 0")}
        />
        
        <p>霧で包まれた朝焼けと稲が刈り取られたばかりの秋の田んぼです。<br /><span css={style.emphasisWeight}>6年&emsp;いちこさん</span></p>
        
        <BackBtn href={"/no161"} />
      </Content>
    </Page>
  )
}
export default Home
